import React from 'react'

const TextInput = React.forwardRef((props, ref) => {
  return <input ref={ref} type="text" {...props} className="form-control" />
})

export default TextInput
